import Button from '../common/Button/Button.component'
import React from 'react'
import Tooltip from '../common/Tooltip/Tooltip.component'
import { convertToUSCurrency } from '../../utils/CurrencyConverterUtil'
import { isEmpty } from 'lodash'
import { toIdSafeString } from '../../utils/StringUtils'
import { usePriceBlur } from '../../hooks/usePriceBlur'
import styled from 'styled-components'
import theme from '../../global/theme'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  align-items: center;
  color: ${theme.colors.textGrey};
`

const PremiumWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 700;
  color: ${theme.colors.primary};
`
interface MonthlyPremiumProps {
  username: string
  premium: number
  loading: boolean
  loaderColor: string
  buttonVariant: 'text' | 'outlined' | 'contained' | undefined
  color:
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'contrastPrimary'
    | undefined
  onEnroll: (forSpouse: boolean, planId: string) => void
  carrierName: string
  planName?: string
  isEnrolled: boolean
  btnText: string
  tooltipContent?: string
  forSpouse: boolean
  enrollmentRedirectURL?: string
  planId: string
  isEappEnabled?: boolean
  retainColorOnDisabled?: boolean
  isFirstCard?: boolean
}

const MonthlyPremium: React.FC<MonthlyPremiumProps> = ({
  buttonVariant,
  loading,
  loaderColor,
  onEnroll,
  premium,
  username,
  color,
  carrierName,
  planName = undefined,
  isEnrolled,
  btnText,
  tooltipContent = undefined,
  forSpouse,
  enrollmentRedirectURL = undefined,
  planId,
  isEappEnabled = false,
  retainColorOnDisabled = false,
  isFirstCard = false,
}) => {
  const isBlurred = usePriceBlur(isFirstCard)
  return (
    <>
      <Container>
        <p>{isEmpty(username) ? `Spouse` : `${username}'s`} Monthly Premium</p>
        <PremiumWrapper>
          <span style={{
            filter: isBlurred ? 'blur(3.5px)' : 'none',
            userSelect: isBlurred ? 'none' : 'auto',
            display: 'inline-block',
            transition: 'filter 0.3s ease',
          }}>
            {convertToUSCurrency(premium)}
          </span>{' '}
          {tooltipContent && <Tooltip title={tooltipContent}></Tooltip>}
        </PremiumWrapper>
        <Button
          loading={loading}
          loaderColor={loaderColor}
          variant={buttonVariant}
          color={retainColorOnDisabled ? 'success' : color}
          onClick={() => {
            if (!isEappEnabled) {
              if (!isEmpty(enrollmentRedirectURL))
                window.open(enrollmentRedirectURL, '_blank')
            }
            onEnroll(forSpouse, planId)
          }}
          disabled={isEnrolled}
          description={`Attempted Enrollment in  ${carrierName} plan ${planName}`}
          id={toIdSafeString(`enroll ${carrierName} plan ${planName || ''}`)}
          width='250px'
          retainColorOnDisabled={retainColorOnDisabled}
        >
          {btnText}
        </Button>
      </Container>
    </>
  )
}

export default MonthlyPremium
